import React from 'react';
import { Grid, GridRow, GridColumn, Popup, Icon } from "semantic-ui-react";
import styles from "./HeaderInvoice.module.scss"
import logo from '../../img/SDClogo64bw.png';
import { COMPANY_NAME, COMPANY_ABBR_GROUP, COMPANY_WWW } from '../../common/constants/company';

const HeaderInvoice: React.FC = () => {
    return (
        <Grid className={styles.grid} >
            <GridRow className={styles.row}>
                <GridColumn width={1}>
                </GridColumn>
                <GridColumn width={5} textAlign='right'>
                    <img src={logo} alt={COMPANY_ABBR_GROUP} />
                </GridColumn>
                <GridColumn width={9} textAlign='left'>
                    <p className={styles.title}>{COMPANY_NAME}</p>
                    <p><a href={COMPANY_WWW}>{COMPANY_WWW}</a></p>
                </GridColumn>
                <GridColumn width={1}>
                    <Popup content='print' position='bottom center'
                        trigger={
                            <Icon circular link size='big' color='teal' name="print" onClick={() => window.print()} />
                        }
                    />
                </GridColumn>
            </GridRow>
        </Grid>
    );
};

export default HeaderInvoice;